import { useState } from "react"

/** Previous-observation and outstanding-payment reminders. */
export function RemindersModal({
  isOpen,
  reminderHtml,
  duePayment: duePaymentProp,
  onClose,
}) {
  const [internalDuePayment] = useState(null);
  const duePayment = duePaymentProp !== undefined ? duePaymentProp : internalDuePayment;
  const hasReminderText = typeof reminderHtml === "string"
    && reminderHtml.replace(/<br\s*\/?>/gi, " ").replace(/<[^>]*>/g, " ").replace(/&nbsp;|\u00a0/gi, " ").trim() !== "";

  if (!isOpen || (!hasReminderText && !duePayment)) return null;

  return (
    <div
      className="modal RemindersModal"
      style={{ position: "fixed", zIndex: 1000000 }}
      onClick={onClose}
    >
      <div
        className="modal-content"
        style={{ position: "fixed", zIndex: 1000000 }}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="modal-header">
          <button
            aria-label="Close reminders"
            className="CloseButton"
            onClick={onClose}
            type="button"
          />
          <h3>Reminders</h3>
        </div>
        <div className="modal-body">
          <div className="reminderAccordian">
            {hasReminderText && (
              <p
                className="reminderText"
                dangerouslySetInnerHTML={{ __html: reminderHtml }}
              />
            )}
            {duePayment && (
              <div className="restToPaySection">
                <strong>Payment rest to pay:</strong> {duePayment}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
